export default __webpack_public_path__ + "ea9496c780c04140ba51a948230ca770.png";